module.exports = __webpack_public_path__ + "img/ring_r_s_1_0.1c9dbe29.png";